import { LiquidityDashboard } from "@/features/treasury/liquidity";

export default function TreasuryLiquidityPage() {
  return <LiquidityDashboard />;
}